module.exports = __webpack_public_path__ + "static/img/check_logo.e247bd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/check_logo.png
// module id = vuYU
// module chunks = 1